import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Paper, Text, Title, Image, Center, Loader } from "@mantine/core";
import { useAuth } from "../contexts/AuthContext.js";
import { authApi } from "../api/auth.js";
import { IconBrandDiscordFilled } from "@tabler/icons-react";
import wwrpLogo from "../static/wwrp_logo2.png";

export function LoginPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate("/", { replace: true });
    }
  }, [loading, user, navigate]);

  if (loading) {
    return (
      <Center style={{ minHeight: "100vh" }}>
        <Loader size="sm" />
      </Center>
    );
  }

  return (
    <main className="login-wrapper">
      <Paper className="login-form" radius="lg">
        <Image src={wwrpLogo} alt="Worldwide Roleplay" h={112} w="100%" fit="contain" mb="sm" />
        <Title order={1} className="login-form-title">
          Welcome back
        </Title>
        <Text c="dimmed" ta="center" mt={6}>
          Sign in to your Worldwide Roleplay Portal account.
        </Text>
        <Button
          className="login-discord-button"
          radius="md"
          size="md"
          fullWidth
          mt="xl"
          leftSection={<IconBrandDiscordFilled size={18} />}
          onClick={() => authApi.loginWithDiscord()}
        >
          Sign in with Discord
        </Button>
        <Text c="dimmed" size="sm" ta="center" mt="md">
          You must be a member of the community to use the Portal.
        </Text>
      </Paper>
    </main>
  );
}
